module.exports = __webpack_public_path__ + "static/media/example3.4161b731.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/quiz/image/example3.png
// module id = 309
// module chunks = 0